import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card } from '../components/ui/card';

const AboutPage = () => {
  const skills = {
    leadership: ['Strategic Thinking', 'Team Collaboration', 'Project Management'],
    collaboration: ['Cross-functional Communication', 'Stakeholder Management', 'Agile Methodologies'],
    tools: ['Figma', 'Adobe XD', 'Sketch', 'Prototyping Tools', 'User Testing Platforms'],
    visual: ['Visual Design', 'Typography', 'Color Theory', 'Design Systems', 'Illustration'],
  };

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        {/* Hero Section with Photo - Similar to reference */}
        <section className="py-24 px-6 bg-gradient-to-br from-gray-900 to-gray-800 min-h-[70vh] flex items-center">
          <div className="max-w-7xl mx-auto w-full">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              {/* Left side - Profile Photo */}
              <div className="flex justify-center lg:justify-start">
                <div className="relative">
                  <div className="w-80 h-80 rounded-full overflow-hidden border-4 border-white/10 shadow-2xl">
                    <img
                      src="https://customer-assets.emergentagent.com/job_plant-care-guide-12/artifacts/hdi7kpth_Photo.jpeg"
                      alt="Ruchi Patel"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>

              {/* Right side - Bio */}
              <div className="space-y-6">
                <h1
                  className="text-5xl md:text-6xl font-bold text-white"
                  style={{ fontFamily: 'DM Sans, sans-serif' }}
                >
                  I'm Ruchi Patel
                </h1>
                <div className="space-y-4 text-white/90 text-lg leading-relaxed">
                  <p>
                    I design with a focus on simplicity, clarity, and human connection. Coming from
                    an architectural background, I approach digital experiences as structured
                    systems—where every element has purpose and guides users intuitively.
                  </p>
                  <p>
                    My goal is to reduce complexity, create seamless interactions, and design
                    experiences that are both functional and emotionally engaging.
                  </p>
                  <p>
                    For the past decade, I've helped companies deliver intuitive solutions across
                    Android, iOS, and web applications. My dual expertise in both product design and
                    development enables me to not only craft engaging user experiences but also bring
                    them to life through high-performance marketing websites and landing pages.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Skills Section */}
        <section className="py-24 px-6 bg-[#EA8649]">
          <div className="max-w-6xl mx-auto">
            {/* Section Header */}
            <div className="mb-16">
              <h2
                className="text-4xl md:text-5xl font-bold mb-4 text-white"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                Skills & Expertise
              </h2>
              <p className="text-white/90 text-lg">What I bring to the table</p>
            </div>

            <div className="grid lg:grid-cols-2 gap-12">
              {/* Skills */}
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-bold mb-4 text-white">Leadership</h3>
                  <Card className="p-6 border-0 shadow-sm bg-white">
                    <ul className="space-y-2">
                      {skills.leadership.map((skill, index) => (
                        <li key={index} className="text-gray-700 flex items-start gap-2">
                          <span className="text-[#EA8649] mt-1">•</span>
                          <span>{skill}</span>
                        </li>
                      ))}
                    </ul>
                  </Card>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-4 text-white">Collaboration & Professional</h3>
                  <Card className="p-6 border-0 shadow-sm bg-white">
                    <ul className="space-y-2">
                      {skills.collaboration.map((skill, index) => (
                        <li key={index} className="text-gray-700 flex items-start gap-2">
                          <span className="text-[#EA8649] mt-1">•</span>
                          <span>{skill}</span>
                        </li>
                      ))}
                    </ul>
                  </Card>
                </div>
              </div>

              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-bold mb-4 text-white">Tools & Software</h3>
                  <Card className="p-6 border-0 shadow-sm bg-white">
                    <div className="flex flex-wrap gap-2">
                      {skills.tools.map((tool, index) => (
                        <span
                          key={index}
                          className="px-3 py-1 bg-[#EA8649]/10 text-[#EA8649] rounded-full text-sm font-medium"
                        >
                          {tool}
                        </span>
                      ))}
                    </div>
                  </Card>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-4 text-white">Visual & Communication</h3>
                  <Card className="p-6 border-0 shadow-sm bg-white">
                    <ul className="space-y-2">
                      {skills.visual.map((skill, index) => (
                        <li key={index} className="text-gray-700 flex items-start gap-2">
                          <span className="text-[#EA8649] mt-1">•</span>
                          <span>{skill}</span>
                        </li>
                      ))}
                    </ul>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;